function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import compact from 'lodash/compact';
import { TableList, Page, PageEmptyState, PageErrorState, FilterPickerGroup, Searchbox, PageContentHeader, Spinner, ConfirmationModal, Typography, DropdownMenu, ChipButton, Button, useStateInRef } from 'seagull';
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import { useGlobalContext, useIoContext, useStore, useStoreActions } from "../../contexts";
import { useSortFromUrl } from "../../hooks/useSortFromUrl";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { useDebouncedLogSearchToBI } from "../../hooks/useDebouncedLogSearchToBI";
import { useOpenEditAgreementModal } from "../../hooks/useOpenEditAgreementModal";
import { selectors } from "../../store/state-selectors";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { getHelpArticle, handlePromise, handleRequest, numberAndUnit } from "../../infra/utils";
import { CreateProposalButton } from "../../components/CreateProposalButton";
import PageLoadingState from "../../components/PageLoadingState";
import SeeWhatItsLike from "../../components/SeeWhatItsLike/SeeWhatItsLike";
import AgreementsDashboardRow from "./AgreementsDashboardRow";
import { NoAgreementsIcon } from "./NoAgreementsIcon";
import { sortAgreements, HeaderColId } from "./AgreementsDashboard.utils";
import img1 from "./SeeWhatItIsLikeImages/1.png";
import img2 from "./SeeWhatItIsLikeImages/2.png";
import { relationshipModel, relationshipSummaryModel } from "../../models";
import { getAgreementPdfUrl } from "../../business-logic/relationshipLogic";
import { useDuplicateRelationship } from "../../hooks/useDuplicateRelationship";
import { useTerminateAgreement } from "../../hooks/useTerminateAgreement";
import { serializeFilter, filtersConfig, FilterSelector, FilterType, deserializeFiltersFromURL, defaultAgreementStatusFilter } from "./agreementsDashboardFilters";
import { useEnterAccountantAccess } from "../../hooks/useEnterAccountantAccess";
import styles from "./AgreementsDashboard.module.scss";
import { useVerifyPlaidBankAccount } from "../../hooks/useVerifyPlaidBankAccount";
import { BankAccountStatusTypes, PlaidBankAccountStatusTypes } from "../../models/payment-method";
import { MailSentLiner24, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import countBy from 'lodash/countBy';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { useRequestPM } from "../../hooks/useRequestPaymentMethod";
import { useBulkActionModal } from "../../hooks/useTerminateAgreement/useBulkActionModal";
import { RelationshipFundingSourceType } from "../../models/relationship-funding-source";
import RenameAgreementModal from "./RenameAgreementModal";
import { ErrorText } from "../../constants";
const title = 'Agreements';
const relationshipLoader = 'getRelationship';
function getTableDefs() {
  const defs = compact([{
    headerItem: {
      id: HeaderColId.companyName,
      value: 'Company name'
    },
    columnDef: {
      width: [180, 400],
      sortable: true
    }
  }, {
    headerItem: {
      id: HeaderColId.status,
      value: 'Status'
    },
    columnDef: {
      width: 100,
      sortable: true
    }
  }, {
    headerItem: {
      id: HeaderColId.effectiveDate,
      value: 'Effective date'
    },
    columnDef: {
      width: [112, 120],
      sortable: true
    }
  }, {
    headerItem: {
      id: HeaderColId.paymentMethod,
      value: 'Payment method'
    },
    columnDef: {
      width: 190,
      sortable: true
    }
  }, {
    headerItem: {
      id: HeaderColId.lastBilled,
      value: 'Last Billed'
    },
    columnDef: {
      width: [112, 120],
      sortable: true
    }
  }]);
  return {
    columnDefs: defs.map(d => d.columnDef),
    headerItems: defs.map(d => d.headerItem)
  };
}
export function ActualAgreementsDashboard(props) {
  const {
    data: _data,
    isRefreshing,
    search,
    filters,
    onChangeFilter,
    refresh,
    onChangeSearch
  } = props;
  const [data, setData] = useState(_data);
  useEffect(() => setData(_data), [_data]);
  const globalContext = useGlobalContext();
  const {
    openNewTab
  } = useIoContext();
  const isVendor = useStore(selectors.user.isVendor);
  const inputDebounceTime = useStore(state => state.appConfig.inputDebounceTime);
  const businessesWithAccountantAccess = useStore(selectors.user.businessesWithAccountantAccess);
  const authDomain = useStore(state => state.session.authDomain);
  const {
    api,
    logBI,
    fetchSidebarCounters
  } = useStoreActions();
  const openEditModeModal = useOpenEditAgreementModal();
  const {
    headerItems,
    columnDefs
  } = useMemo(() => getTableDefs(), []);
  const sortIds = useMemo(() => headerItems.map(item => item.id), [headerItems]);
  const defaultSort = useMemo(() => ({
    colIndex: 2,
    sort: 'desc'
  }), []);
  const {
    sort,
    changeSort
  } = useSortFromUrl({
    defaultSort,
    sortIds
  });
  const {
    duplicateRelationshipAndRedirect
  } = useDuplicateRelationship();
  const {
    terminateAgreementById
  } = useTerminateAgreement();
  const enterAccountantAccess = useEnterAccountantAccess();
  const verifyPlaidBankAccount = useVerifyPlaidBankAccount();
  const scrollElRef = useRef(null);
  const debouncedLogSearchToBI = useDebouncedLogSearchToBI(11252, 0);
  const onRequestPM = useRequestPM();
  const {
    doBulkAction
  } = useBulkActionModal();
  const [initialFilters, setInitialFilters] = useState(Object.values(FilterType).filter(type => filtersConfig[type].hasValue(filters[type])));
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selected, setSelected] = useState({});
  const getSelected = useStateInRef(selected);
  const [bulkActionsOpen, setBulkActionsOpen] = useState(false);
  const numSelected = useMemo(() => {
    var _countBy$true;
    return (_countBy$true = countBy(selected).true) !== null && _countBy$true !== void 0 ? _countBy$true : 0;
  }, [selected]);
  const allFilters = initialFilters.concat(selectedFilters);
  const agreements = useMemo(() => {
    return sortAgreements({
      agreements: data,
      sort,
      isVendor,
      headerItems
    });
  }, [data, sort, isVendor, headerItems]);
  const {
    paginatedData,
    onScroll
  } = useInfiniteScroll({
    data: agreements,
    scrollElRef
  });
  const [registerSearchBoxHotkey, setRegisterSearchBoxHotkey] = useState(true);
  useEffect(() => {
    // this unselects any agreement that is not found in the newly fetched list of agreements
    if (!data || isEmpty(getSelected())) return;
    const ids = data.map(agreement => agreement.id);
    const newSelected = mapValues(getSelected(), (origValue, agreementId) => ids.includes(agreementId) ? origValue : false);
    setSelected(newSelected);
  }, [data]);
  const onToggleAllSelection = useCallback(selectAll => {
    setSelected(agreements.reduce((acc, _ref) => {
      let {
        id
      } = _ref;
      return Object.assign(acc, {
        [id]: selectAll
      });
    }, {}));
  }, [agreements]);
  function onVerifyPaymentMethod(agreement) {
    if (!agreement.fundingSource) return;
    if (agreement.fundingSource.type === RelationshipFundingSourceType.Ach && agreement.fundingSource.ach.status === BankAccountStatusTypes.PlaidVerification) {
      verifyPlaidBankAccount({
        fundingSourceId: agreement.fundingSource.id,
        onVerify() {
          // Optimistic UI.
          const newData = data.map(r => r.id === agreement.id ? relationshipSummaryModel.setFundingSourcePlaidVerificationStatus(r, PlaidBankAccountStatusTypes.ManuallyVerified) : r);
          setData(newData);
        },
        onVerifyFailed() {
          // Optimistic UI.
          const newData = data.map(r => r.id === agreement.id ? relationshipSummaryModel.setFundingSourcePlaidVerificationStatus(r, PlaidBankAccountStatusTypes.VerificationFailed) : r);
          setData(newData);
        }
      });
    }
  }
  const onSortChange = sort => {
    logBI(11250, {
      column: sort ? sortIds[sort.colIndex] : 'none'
    });
    changeSort(sort);
  };
  const onClearSearch = () => {
    onChangeSearch('');
    debouncedLogSearchToBI.onClear();
  };
  const onDownloadPDF = agreement => {
    openNewTab(getAgreementPdfUrl(agreement.id, authDomain));
  };
  const onTerminateAgreement = agreement => {
    terminateAgreementById({
      id: agreement.id,
      postAction: () => {
        refresh();
        fetchSidebarCounters();
      }
    });
  };
  const onEditAgreement = agreement => {
    openEditModeModal({
      relationshipId: agreement.id,
      onUpdate: refresh
    });
  };
  const onDuplicateAgreement = agreement => {
    duplicateRelationshipAndRedirect(agreement.id);
  };
  function addFilter(type) {
    setSelectedFilters(selectedFilters.concat(type));
  }
  function removeFilter(type) {
    setInitialFilters(initialFilters.filter(t => t !== type));
    setSelectedFilters(selectedFilters.filter(t => t !== type));
    onChangeFilter(type, filtersConfig[type].getEmptyValue());
  }
  function getSelectedAgreements() {
    return Object.entries(selected).filter(_ref2 => {
      let [, isSelected] = _ref2;
      return isSelected;
    }).map(_ref3 => {
      let [agreementId, _] = _ref3;
      return agreementId;
    });
  }
  async function bulkRequestPaymentMethod(selectedAgreements) {
    logBI(11254, {
      count: selectedAgreements.length
    });
    await doBulkAction({
      bulkItemIds: selectedAgreements,
      confirmationTitle: 'Request Payment Method',
      confirmationPrimaryButtonLabel: 'Send Request',
      confirmationContent: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "By selecting \"Send Request\", all clients of the selected", ' ', /*#__PURE__*/React.createElement("strong", null, selectedAgreements.length), " agreements will receive an email asking them to set up their payment details in Anchor."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, null, "Consider sending a personal message to clients still transitioning to Anchor to communicate the purpose of this request."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ExternalLinkButton, {
        openInNewTab: true,
        href: getHelpArticle('8344568-about-request-payment-method')
      }, "Learn more about Request Payment Method")),
      progressTitle: 'Request Payment Method',
      actionName: 'sent',
      itemName: 'payment method request',
      onConfirmed: () => {
        logBI(11255, {
          count: selectedAgreements.length
        });
      },
      canProcessItem: itemId => agreements.find(a => a.id === itemId && !relationshipModel.isTerminated(a)) != null,
      processSingleItem: agreementId => handlePromise(api.relationship.requestPaymentMethod(agreementId)).then(result => [result.data, null, !result.success]),
      onDone: failedAgreementIds => {
        setSelected(failedAgreementIds.reduce((acc, agreementId) => _objectSpread(_objectSpread({}, acc), {}, {
          [agreementId]: true
        }), {}));
      }
    });
  }
  async function onRenameAgreement(agreement, onSuccess) {
    globalContext.startLoader(relationshipLoader);
    const relationship = await handleRequest(api.relationship.get(agreement.id));
    globalContext.stopLoader(relationshipLoader);
    if (!relationship.success) {
      globalContext.showErrorToast(ErrorText.UnexpectedErrorTryAgain, 'get-agr-error');
    } else {
      globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: p => /*#__PURE__*/React.createElement(RenameAgreementModal, _extends({}, p, {
          relationship: relationship.data,
          onSuccess: onSuccess
        }))
      });
    }
  }
  const openImportAgreementsModal = () => {
    globalContext.showModal({
      content: _ref4 => {
        let {
          dismissModal
        } = _ref4;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          textAlignCenter: false,
          primaryButtonLabel: "Close",
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal,
          title: "Import agreements",
          primaryButtonTestid: "close-import-agreements-modal",
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Need to import agreements into Anchor that were signed elsewhere?"), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(ExternalLinkButton, {
            openInNewTab: true,
            href: "https://forms.gle/Q9sMHXFcp5Fs866FA"
          }, "Complete this form"), ' ', "and our team will reach out with the next steps."), /*#__PURE__*/React.createElement(Typography, {
            variant: "paragraph2",
            style: {
              marginTop: '16px'
            }
          }, "Please note: This service is currently available for requests of 30 agreements or more."))
        });
      }
    });
  };
  return data.length > 0 || allFilters.length > 0 || search.length || isRefreshing ? /*#__PURE__*/React.createElement(Page, {
    "data-testid": "agreements-dashboard",
    header: title,
    ref: scrollElRef,
    actions: isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "import-agreements-btn",
      onClick: () => openImportAgreementsModal()
    }, "Import"), /*#__PURE__*/React.createElement(CreateProposalButton, {
      key: "new-agreement-button"
    })),
    subheader: numberAndUnit(data.length, 'agreement'),
    onScroll: onScroll
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    hasActionColumn: true,
    enableRowSelection: isVendor,
    columnDefs: columnDefs,
    sort: sort,
    selectedRows: selected,
    onSortChange: onSortChange,
    onSelectionChange: setSelected,
    numRows: agreements.length,
    numSelectedRows: numSelected,
    onToggleAllSelection: onToggleAllSelection
  }, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBlockEnd: '24px'
    }
  }, /*#__PURE__*/React.createElement(FilterPickerGroup, {
    flexWrap: true,
    "data-testid": "agreements-dashboard-filters"
  }, /*#__PURE__*/React.createElement(Searchbox, {
    registerHotkey: registerSearchBoxHotkey,
    value: search,
    "data-testid": "agreements-dashboard-search",
    debounceTime: inputDebounceTime !== null && inputDebounceTime !== void 0 ? inputDebounceTime : 500,
    onClear: onClearSearch,
    onChange: event => {
      const searchStr = event.target.value;
      onChangeSearch(searchStr);
      debouncedLogSearchToBI.onChange(searchStr);
    }
  }), allFilters.map(type => /*#__PURE__*/React.createElement(filtersConfig[type].component, {
    key: type,
    startOpen: selectedFilters.includes(type),
    value: filters[type],
    onChange: v => onChangeFilter(type, v),
    onRemove: () => removeFilter(type),
    onInputFocus: () => setRegisterSearchBoxHotkey(false),
    onInputBlur: () => setRegisterSearchBoxHotkey(true)
  })), allFilters.length < Object.keys(filters).length && /*#__PURE__*/React.createElement(FilterSelector, {
    selected: allFilters,
    onSelect: addFilter
  }), isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.selectedItems,
    "data-testid": "agreement-dashboard-bulk-counter"
  }, numSelected > 0 ? "".concat(numberAndUnit(numSelected, 'agreement'), " selected") : ''), /*#__PURE__*/React.createElement(DropdownMenu, {
    onOpenChange: setBulkActionsOpen,
    target: /*#__PURE__*/React.createElement(ChipButton, {
      "data-testid": "agreement-dashboard-bulk-actions",
      suffixIcon: bulkActionsOpen ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null),
      highlight: bulkActionsOpen,
      disabled: numSelected === 0
    }, "Bulk actions")
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement(MailSentLiner24, null),
    "data-testid": "agreement-dashboard-bulk-request-payment-method",
    onClick: () => bulkRequestPaymentMethod(getSelectedAgreements()),
    disabled: !isVendor
  }, "Request payment method"))))), /*#__PURE__*/React.createElement(TableList.Header, {
    items: headerItems,
    "data-testid": "agreements-dashboard-table-header"
  })), isRefreshing ? /*#__PURE__*/React.createElement("div", {
    className: styles.loading,
    "data-testid": "agreements-table-loading"
  }, /*#__PURE__*/React.createElement(Spinner, null)) : agreements.length ? paginatedData.map((agreement, index) => /*#__PURE__*/React.createElement(AgreementsDashboardRow, {
    key: agreement.id,
    agreement: agreement,
    hasAccountantAccess: isVendor && businessesWithAccountantAccess.has(relationshipSummaryModel.customerBusinessId(agreement)),
    isVendor: isVendor,
    index: index,
    onVerifyPaymentMethod: onVerifyPaymentMethod,
    onEditAgreement: onEditAgreement,
    onDownloadPDF: onDownloadPDF,
    onDuplicateAgreement: onDuplicateAgreement,
    onTerminateAgreement: onTerminateAgreement,
    onEnterAccountantAccess: enterAccountantAccess,
    onRequestPM: onRequestPM,
    onRenameAgreement: onRenameAgreement
  })) : /*#__PURE__*/React.createElement(PageEmptyState, {
    illustration: /*#__PURE__*/React.createElement(NoAgreementsIcon, null),
    title: "No agreements match your request",
    message: "Try adjusting your search",
    "data-testid": "agreements-empty-table"
  }))) : /*#__PURE__*/React.createElement(Page, {
    header: title,
    loading: isRefreshing
  }, /*#__PURE__*/React.createElement(PageEmptyState, {
    "data-testid": "agreements-empty",
    illustration: /*#__PURE__*/React.createElement(NoAgreementsIcon, null),
    title: "Make it official with an online agreement",
    message: "The Anchor agreement can always be updated, is accessible online, and serves as a single source of truth between you and your clients.",
    actions: isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SeeWhatItsLike, {
      steps: [{
        title: 'A single place to maintain client information',
        subtitle: 'All aspects of your agreement and relationship history live here, online, equally visible to you and your client.',
        image: {
          src: img1,
          width: 1246,
          height: 748
        }
      }, {
        title: 'Hands-free relationship management ',
        subtitle: 'You and your clients will be updated on any changes or required action.',
        image: {
          src: img2,
          width: 1246,
          height: 748
        }
      }],
      "data-testid": "agreements-dashboard"
    }), /*#__PURE__*/React.createElement(CreateProposalButton, {
      text: "Create a new agreement",
      hidePrefix: true,
      "data-testid": "agreements-empty-new-btn"
    }))
  }));
}
export default function AgreementsDashboard() {
  const {
    api
  } = useStoreActions();
  const businessId = useStore(selectors.user.businessId);
  const isVendor = useStore(selectors.user.isVendor);
  const shouldRefresh = useRef(false);
  const refreshRef = useRef(() => {});
  const {
    urlState,
    changeUrlState
  } = useStateFromUrl({
    search: {
      defaultValue: ''
    },
    agreementStatus: {
      multi: true,
      applyDefaultOnlyOnMount: true,
      defaultValue: defaultAgreementStatusFilter
    },
    effectiveDate: {
      defaultValue: ''
    },
    lastBillingDate: {
      defaultValue: ''
    },
    paymentMethod: {
      multi: true
    },
    completion: {
      multi: true
    },
    recurrence: {
      multi: true
    },
    hasCredit: {
      multi: true
    },
    automatic: {
      multi: true
    },
    billingTrigger: {
      multi: true
    },
    serviceNames: {
      multi: true
    },
    servicePriceIncreaseState: {
      multi: true
    }
  });
  const {
    search
  } = urlState;
  const deserializedFilters = useMemo(() => deserializeFiltersFromURL(urlState), [urlState]);
  useEffect(() => {
    document.title = title;
  }, []);
  useEffect(() => {
    if (shouldRefresh.current) {
      refreshRef.current();
    }
  }, [urlState]);
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => {
      if (!businessId) return Promise.resolve([]);
      return api.relationship.getSummaries({
        businessId,
        type: 'agreement',
        isVendor,
        search,
        filters: deserializedFilters
      });
    },
    renderLoader: () => /*#__PURE__*/React.createElement(PageLoadingState, {
      header: title,
      loading: true
    }),
    renderError: _ref5 => {
      let {
        refresh
      } = _ref5;
      return /*#__PURE__*/React.createElement(PageErrorState, {
        title: title,
        onRefresh: refresh
      });
    },
    renderChild: _ref6 => {
      let {
        data,
        loading,
        refresh
      } = _ref6;
      refreshRef.current = refresh;
      function refreshOnUrlStateChange() {
        shouldRefresh.current = true;
      }
      return /*#__PURE__*/React.createElement(ActualAgreementsDashboard, {
        data: data,
        isRefreshing: loading,
        refresh: refresh,
        search: search,
        filters: deserializedFilters,
        onChangeFilter: (type, value) => {
          refreshOnUrlStateChange();
          changeUrlState({
            [type]: serializeFilter(type, value)
          });
        },
        onChangeSearch: search => {
          refreshOnUrlStateChange();
          changeUrlState({
            search
          });
        }
      });
    }
  });
}